import { useState, useCallback } from 'react';
import { message } from 'antd';
import { g303Api, QueryRequest, QueryResponse } from '../../../services/g303Api';

export interface G303QueryState {
  loading: boolean;
  result: QueryResponse | null;
  queried: boolean;
  noData: boolean;
}

export interface G303QueryActions {
  runQuery: (req: QueryRequest) => Promise<void>;
  reset: () => void;
}

export function useG303Query(): G303QueryState & G303QueryActions {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<QueryResponse | null>(null);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (req: QueryRequest) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await g303Api.query(req);
      if (resp.details && resp.details.length > 0) {
        setResult(resp);
        setNoData(false);
      } else {
        setResult(null);
        setNoData(true);
        message.info('查無符合條件的應收帳款月份統計資料');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setResult(null);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, result, queried, noData, runQuery, reset };
}
